import { render } from "./DataPostView.vue?vue&type=template&id=da18f56a"
import script from "./DataPostView.vue?vue&type=script&lang=js"
export * from "./DataPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__